import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { InputNumberModule } from "primeng/inputnumber";

@Component({
  selector: 'app-custom-field-numeric',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomFieldNumericComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CustomFieldNumericComponent),
      multi: true
    }
  ],
  templateUrl: './numeric.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputNumberModule,
],
  styleUrls: ['../../styles/fields.scss']
})
export class CustomFieldNumericComponent implements OnInit, ControlValueAccessor{

  @Input()
  public readonly: boolean;

  public internalValue: any;

  onChange: (_: string) => void = (_: string) => { };

  constructor() { }

  ngOnInit(): void { }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(): void { }

  writeValue(val: string): void {
    this.internalValue = val
      ? parseInt(val)
      : null;
  }

  validate({ value }: FormControl) {
    return false;
  }

  updateChanges(value: any) {
    this.onChange(value.toString());
  }
}
